<template>
  <div class="has-text-grey-darker has-text-weight-normal">
    <div v-if="onlyTime" class="is-inline-block" style="margin-top: 2px; margin-left: -1px; ">
      <span class="icon is-small">
        <i class="mdi mdi-clock-outline mdi-16px"></i>
      </span>
      <time
        style="padding-left: 4px"
        itemprop="startDate"
        :datetime="eventShowtimes[0].startTime | toHTMLDateTime"
      >{{ eventShowtimes[0].startTime | toTime }}</time>
      <time
        v-if="$options.filters.toTime(eventShowtimes[0].startTime) !== $options.filters.toTime(eventShowtimes[0].endTime)"
        :datetime="eventShowtimes[0].endTime | toHTMLDateTime"
      >&nbsp;- {{ eventShowtimes[0].endTime | toTime }}</time>
    </div>
    <!-- :class="{ 'is-size-14px': !fontSm, 'is-size-13px': fontSm }" -->
    <div v-else-if="!isEventContinue(eventShowtimes[0].startTime, eventShowtimes[0].endTime)">
      <span
        v-if="isDayHighlighted(eventShowtimes[0].startTime)"
      >{{ setDayName(eventShowtimes[0].startTime) }}</span>
      <span
        v-if="!isDayHighlighted(eventShowtimes[0].startTime)"
      >{{ setDayName(eventShowtimes[0].startTime) }}</span>
      <time
        itemprop="startDate"
        :content="eventShowtimes[0].startTime | toHTMLDate"
        :datetime="eventShowtimes[0].startTime | toHTMLDate"
      >
        {{ eventShowtimes[0].startTime.getDate() }}
        {{ $t(`monthNames.${eventShowtimes[0].startTime.getMonth()}`).substring(0,3) }}
      </time>

      <span v-if="!onlyDate" class="dot is-seperator">•&nbsp;</span>
      <time
        v-if="!onlyDate"
        :datetime="eventShowtimes[0].startTime | toHTMLDateTime"
      >{{ eventShowtimes[0].startTime | toTime }}</time>
      <div
        v-if="showExtraDates && Object.keys(eventShowtimes).length > 1"
        style="margin-left: 4px"
        class="is-lowercase has-text-weight-normal is-size-7 is-inline has-text-grey"
      >({{ $t('ui.extraDates', {msg: Object.keys(eventShowtimes).length - 1}) }})</div>
    </div>

    <div v-else>
      <time
        itemprop="startDate"
        :content="eventShowtimes[0].startTime | toHTMLDate"
        :datetime="eventShowtimes[0].startTime | toHTMLDate"
      >
        {{ eventShowtimes[0].startTime.getDate() }}
        {{ $t(`monthNames.${eventShowtimes[0].startTime.getMonth()}`).slice(0,3) }} -
        {{ eventShowtimes[0].endTime.getDate() }}
        {{ $t(`monthNames.${eventShowtimes[0].endTime.getMonth()}`).slice(0,3) }}
        <!-- <span
          :class="{ 'has-text-info': isDayHighlighted(eventShowtimes[0].startTime) }"
        >{{ setDayName(eventShowtimes[0].startTime) }}&nbsp;</span>-->
        <!-- {{ $t(`dayNames.${event.data.eventShowtimes[0].startTime.getDay()}`).substring(0,3) }} -->
      </time>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    eventShowtimes: {
      type: Object,
      required: true
    },
    fontSm: {
      type: Boolean,
      default: true
    },
    showType: {
      type: Boolean,
      default: false
    },
    onPoster: {
      type: Boolean,
      default: false
    },
    onlyTime: {
      type: Boolean,
      default: false
    },
    onlyDate: {
      type: Boolean,
      default: false
    },
    showExtraDates: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    setDayName(startTime) {
      const today = new Date();
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);

      if (
        startTime.getDate() === today.getDate() &&
        startTime.getDay() === today.getDay()
      ) {
        return this.$t("ui.today");
      } else if (
        startTime.getDate() === tomorrow.getDate() &&
        startTime.getDay() === tomorrow.getDay()
      ) {
        return this.$t("ui.tomorrow");
      } else {
        return this.$t(`dayNames.${startTime.getDay()}`).substring(0, 3);
      }
    },
    isDayHighlighted(startTime) {
      const today = new Date();
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      if (
        (startTime.getDate() === today.getDate() &&
          startTime.getDay() === today.getDay()) ||
        (startTime.getDate() === tomorrow.getDate() &&
          startTime.getDay() === tomorrow.getDay())
      ) {
        return true;
      } else {
        return false;
      }
    },
    isEventContinue(startTime, endTime) {
      // return false
      if (startTime.getDate() !== endTime.getDate()) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
